export function hasMoreThanOneItem(arrayOfItems) {
  if (!arrayOfItems) return false;
  return arrayOfItems.length > 1;
}

export function hasKeys(obj) {
  if (!obj) return false;
  return !!Object.keys(obj).length;
}
